import React from 'react';
import './OtpInput.css';

const OtpInput = ({
  index,
  inputRef,
  value,
  ...inputProps
}) => (
  <input
    ref={inputRef}
    aria-label={`OTP code (index ${index + 1})`}
    className="otp-input"
    id={`otp-input-${index}`}
    max={1}
    value={value}
    {...inputProps}
  />
);

export { OtpInput };
